module.exports = __webpack_public_path__ + "web_static/img/TwinImage.05d68a8a.png";